// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const HUTECS_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  drugCode: ['보험코드'],
  drugName: ['제품명'],
  quantity: ['수량'],
  unitPrice: ['단가'],
  prescriptionAmount: ['청구실적'],
  settlementAmount: ['확정수수료'],
  feeRate: ['%'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '사업자번호',
  '처방처명',
  '보험코드',
  '제품명',
  '수량',
  '단가',
  '청구실적',
  '확정수수료',
  '%',
  '처방년월',
  '비고',
];

const TARGET_SHEET_NAME = '제품별';

function isHutecsProfile(profile) {
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader(TARGET_SHEET_NAME) &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const hutecsPharmTemplate = {
  id: 'hutecs-pharm',
  name: '한국휴텍스제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isHutecsProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isHutecsProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(HUTECS_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '한국휴텍스제약';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: row[columnMap.hospitalName],
        drugCode: row[columnMap.drugCode],
        drugName,
        quantityValue: row[columnMap.quantity],
        unitPriceValue: row[columnMap.unitPrice],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        settlementAmountValue: row[columnMap.settlementAmount],
        feeRateValue: row[columnMap.feeRate],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default hutecsPharmTemplate;
